import { ReactElement } from 'react';
import styles from './verify-email-page.module.scss';
import { Navigate, useParams, useSearchParams } from 'react-router';
import SafepointLogo from '@/common/assets/images/safepoint-logo-dark.svg?react';
import { UISpacer } from '@/ui';
import { VerifyEmail } from '@/me/components';
import { useOpenApi } from '@/common/providers/open-api-provider';
import { useUnauthenticatedApi } from '@/common/hooks';
import { REGION_CONFIGS } from '@/common/providers/region-provider/constants';
import { ResolvedRegion } from '@/common/providers/region-provider/models';

export function VerifyEmailPage(): ReactElement {
    const { token } = useParams();
    const [searchParams] = useSearchParams();
    const regionParam = searchParams.get('r')?.toLowerCase();

    // Determine region: use query param if valid, otherwise default to 'eu'
    const region: ResolvedRegion =
        regionParam === 'eu' || regionParam === 'us' ? regionParam : 'eu';

    const { openApi } = useOpenApi();
    useUnauthenticatedApi({
        baseUrl: REGION_CONFIGS[region].apiBaseUrl,
        axiosInstance: openApi.instance
    });

    if (!token) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className={styles.page}>
            <SafepointLogo width={300} />
            <UISpacer multiplier={4} />
            <div className={styles.card}>
                <VerifyEmail token={token} />
            </div>
        </div>
    );
}
